import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import QuasarFileUploader from 'SharedComponents/ui/File/QuasarFileUploader.vue';
import { ATTACHMENT_ENDPOINTS } from 'SharedDir/backend/endpoints/attachments';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { AttachmentType } from 'SharedDir/declarations/files';
import { useAuthStore } from 'SharedDir/stores/auth.store';

interface FileParameterOptions {
  label: string;
  readonly?: boolean;
  required?: boolean;
  isPublic?: boolean;
  authorizedOnly?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FileParameter', components: { QuasarFileUploader } },
  __name: 'File',
  props: {
    modelValue: {},
    label: {},
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    isPublic: { type: Boolean, default: true },
    authorizedOnly: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;
const { innerValue, emitValue } = useValue<string | null, Partial<AttachmentType> | null>(
  props,
  emit,
  {
    transform: (value) => (value ? { id: value } : null),
    mrofsnart: (value) => value?.id || null,
  }
);
const store = useAuthStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(QuasarFileUploader, {
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      _unref(emitValue)
    ],
    label: _ctx.label,
    class: "s-form-input_wrapper",
    required: _ctx.required,
    readonly: _ctx.readonly,
    api: _unref(ATTACHMENT_ENDPOINTS),
    token: _unref(store).token,
    "form-fields": { isPublic: _ctx.isPublic, authorizedOnly: _ctx.authorizedOnly },
    onRemove: _unref(emitValue)
  }, null, 8, ["modelValue", "label", "required", "readonly", "api", "token", "form-fields", "onUpdate:modelValue", "onRemove"]))
}
}

})